module.exports = __webpack_public_path__ + "static/img/miL.48c5575a.svg";